export const /** @type {?} */ SelectableTemplates = {
  defaultTemplate: {
    property: {
      display: true,
      disable: false,
      value: '',
      item: null,
      checked: false,
      itemPosition: 'after'
    }
  }
}
